import React, { useState, useCallback, useEffect } from 'react'
import './index.scss'

import { isIphoneX } from 'multiPublic/index'
import WebchatOpenInBrowser from '../../components-m/WebchatOpenInBrowser'
import useAppDownload from '../../public/hooks/useAppDownload'
import phoneIcon from './images/cellphone-icon.png'
import marsAI from './images/mars-ai-white.png'
import { mixUrl } from '../../public/'

export default (props) => {
    const [iphonex, setIphonex] = useState(false)
    const [openInBrowser, setOpenInBrowser] = useState(false)
    const appDownload = useAppDownload()
    const clickDownload = useCallback(() => {
        setOpenInBrowser(appDownload(props.type, props.id))
    }, [])
    useEffect(() => {
        isIphoneX() && setIphonex(true)
    }, [])
    return <div className={`download-app-wrapper ${iphonex ? 'iphonex' : ''}`}>
        <a className="download-app-btn" onClick={clickDownload}>
            <img src={phoneIcon} alt="下载MarsBit"/>
            下载MarsBit APP
        </a>

        {/* mars-ai */}
        <div style={{ float: 'right', marginLeft: '16px', display: 'flex', alignItems: 'center' }}>
            <a style={{ borderRadius: '100%', background: '#0056ff', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '37px', width: '37px', overflow: 'hidden', boxShadow: '0 0.125rem 0.2916666667rem rgba(26, 26, 26, 0.25)' }} href={mixUrl.main('/chat/start')}>
                <img style={{ height: '80%', width: '80%', display: 'block', opacity: '1' }} src={marsAI} alt='mars-ai'/>
            </a>
        </div>

        <WebchatOpenInBrowser openInBrowser={openInBrowser} setOpenInBrowser={setOpenInBrowser} />
    </div >
}
